import { slugify as slugifyFn } from 'transliteration';

export default value => slugifyFn(value);
